module.exports = __webpack_public_path__ + "img/mobile-1.c65dd06a.png";